import { ResetPasswordForm } from '@/features/auth'

function ResetPassword() {
  return (
    <div className="w-screen h-screen flex flex-row justify-center items-center mesh-bg-secondary p-4 overflow-y-scroll">
      <div className="flex flex-col bg-white rounded md:w-[600px] p-6 gap-2.5 max-w-screen">
        <ResetPasswordForm />
      </div>
    </div>
  )
}

export default ResetPassword
